import {Component, OnDestroy, OnInit} from "@angular/core";
import {WorkflowStep} from "../workflow-step";
import {ActivatedRoute, Router} from "@angular/router";
import {WorkflowService} from "../workflow.service";
import {WorkflowTargetInfoModel} from "../models/workflow-target-info.model";
import {BillingDestinations, PricingModels} from "../../types/customer-setup-details";
import {CustomerService} from "../../customer/customer-service";
import {CustomerModel, customerModelFactory} from "../../customer/customer.model";
import {ProjectService} from "../../project/project.service";
import {handleErrors} from "../../misc/handle-errors.decorator";
import {Subscription} from "rxjs";
import {AppSettingsService} from "../../app-settings/app-settings.service";

@Component({
  templateUrl: "create-assign-customer.template.pug",
  providers: [CustomerService, ProjectService],
})
export class CreateAssignCustomerComponent extends WorkflowStep implements OnInit, OnDestroy {
  error: Error;
  projectId: string;
  billingDestinations: any = BillingDestinations;
  pricingModels: any = PricingModels;
  customer: CustomerModel = customerModelFactory();
  isEmea: boolean = false;
  private userSubscription: Subscription;

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public workflowService: WorkflowService,
    public customerService: CustomerService,
    public projectService: ProjectService,
    private appSettingsService: AppSettingsService,
  ) {
    super();
  }

  public ready(workflowTargetInfo: WorkflowTargetInfoModel) {
    this.projectId = workflowTargetInfo.targetId;
    if (this.workflowService.workflowConfig.geoRegionId === "EMEA") this.isEmea = true;
  }

  @handleErrors()
  async createCustomer() {
    const result = await this.customerService.createCustomer(this.customer);

    await this.projectService.saveCustomer(this.projectId, result.id, result.name).toPromise();

    this.router.navigate([`/workflow/${this.workflowService.workflowConfig.id}/${this.workflowTargetInfo.stepName}`]);
  }

  usageCollectionChanged(): void {
    if (!this.customer.doUsageCollection) {
      this.customer.doTonerMonitoring = false;
      this.customer.doTonerAutoOrder = false;
      this.customer.doInkMonitoring = false;
      this.customer.doInkAutoOrder = false;
      this.customer.doPrintHeadMonitoring = false;
      this.customer.doPrintHeadAutoOrder = false;
      this.customer.doMaintenanceMonitoring = false;
      this.customer.doMaintenanceAutoOrder = false;
      this.customer.doFastenerMonitoring = false;
      this.customer.doFastenerAutoOrder = false;
    }
  }

  emeaTonerChanged(): void {
    this.customer.doTonerAutoOrder = this.customer.doTonerMonitoring;
    this.customer.doInkMonitoring = this.customer.doTonerMonitoring;
    this.customer.doInkAutoOrder = this.customer.doTonerMonitoring;
  }

  emeaPrintHeadChanged(): void {
    this.customer.doPrintHeadAutoOrder = this.customer.doPrintHeadMonitoring;
  }

  emeaFastenerChanged(): void {
    this.customer.doFastenerAutoOrder = this.customer.doFastenerMonitoring;
  }

  ngOnInit() {
    super.ngOnInit();
    this.userSubscription = this.appSettingsService.user.subscribe((user) => {
      this.customer.email = user.emailAddress;
    });
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.userSubscription && !this.userSubscription.closed) {
      this.userSubscription.unsubscribe();
    }
  }
}
